const i18n = {
  t (key) {
    return key
  },
}

export default i18n
